








import {Vue, Component, Prop} from 'vue-property-decorator'
import ListTags from "./ListTags";


@Component({name:"ui-tags-simple-list"})
export default class UiTagsSimpleList extends Vue{
  @Prop({ default: () => {}, type: Array })
  Items!: Array<ListTags>;  
  
  count(){
    
      return this.Items.length-1;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-tags/src/ui-tags-simple-list.vue